<template>
<div class="navbar">
    <div class="logo"><img src="../assets/img/LOGO.png" alt="焰川网络logo"></div>
    <div class="nav">
    <router-link class="first" to="/home">首页</router-link>
    <router-link class="first" to="/about">关于我们</router-link>
    <router-link class="first" to="/product">产品与服务</router-link>
    <router-link class="first" to="/news">新闻资讯</router-link>
    <router-link class="first" to="/share">案例分享</router-link>
    <router-link class="first" to="/contact">联系我们</router-link>
    <router-view />
    </div>
</div>
</template>
<style lang="scss" scope>
*{
    padding: 0;
    margin: 0;
}
    .navbar{
        width: 100%;
        height: 70px;
        // text-align: center;
        // margin-left: 50px;
    }
    .navbar .logo{
        width: 29.166667%;
        height: 70px;
        float: left;
        img{
            width: 200px;
            height: 100%;
        }
    }
    .navbar .nav{
        width: 60%;
        height: 70px;
        float: right;
    }
    // .nav .first{
    //     background: #24C0EA;
    //     color: #fff;
    // }
    .nav a{
        // background: #fff;
        color: #BBBBBB;
        font-size: 18px;
        text-align: center;
        display: block;
        width: 16.666667%;
        height: 70px;
        line-height: 70px;
        float: left;
        text-decoration: none;
    }
    .first.router-link-active{
        background: #24C0EA;
        color: #fff !important;
    }
    .nav a:hover{
        background: #24C0EA;
        color: #fff;
    }
    // @media screen and (max-width: 480px){
    //     .navbar{
    //         width: 100%;
    //     }
    // }
</style>
<script>
export default {
    data() {
        return {
            
        }
    },
}
</script>